GP.vent.on('init_js:user:validate_email', function(self) {
    self.showMoreOptions = function(divID) {
        var divArray = [
            "gmailID",
            "yahooID",
            "aolID",
            "windowsliveID",
            "outlookID"
        ];

        for (var i = 0; i < divArray.length; i++) {
            if (divArray[i] == divID) {
                document.getElementById(divArray[i]).style.display = 'block';
            } else {
                document.getElementById(divArray[i]).style.display = 'none';
            }
        }
        if (divID == 'noneID') {
            document.getElementById('email-help').style.display = 'none';
        }
    };

    var div_id = 'noneID';
    if (typeof _validate_email_init != 'undefined' && _validate_email_init.hasOwnProperty('js_domain_id')) {
        div_id = _validate_email_init.js_domain_id;
    }

    self.showMoreOptions(div_id);
});
